import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortModel } from '@common/models/sort.model';
import { Observable } from 'rxjs';

import { ApiAbstraction } from './api.abstraction';

@Injectable()
export class RelatedAssetsApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public getRelatedAssetsByAssetId(
    offset: number,
    limit: number,
    id: ID,
    sort: SortModel
  ): Observable<PaginatedResponseDAO<AssetDAO>> {
    const params = new HttpParams()
      .set('offset', offset)
      .set('limit', limit)
      .set('sortField', sort.field)
      .set('sortOrder', sort.order);

    return this.httpClient.get<PaginatedResponseDAO<AssetDAO>>(`${this.baseUrl}/assets/${id}/related-assets`, {
      params
    });
  }
}
